import { PropsWithChildren } from 'react';
import { IconProps } from './types';

export const JarIcon = ({ title = 'Jar Icon', children, ...props }: IconProps & PropsWithChildren) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="103"
        height="167"
        fill="none"
        viewBox="0 0 103 167"
        role="img"
        aria-labelledby="jarIconTitle"
        {...props}
    >
        <title id="jarIconTitle">{title}</title>
        <defs>
            <mask id="jarMask">
                <path
                    fill="white"
                    d="M101.079 56.235v97.45c0 6.302-5.134 11.403-11.46 11.403H13.382c-6.334 0-11.46-5.109-11.46-11.403V56.228c0-13.239 10.791-23.977 24.095-23.977v-8.565H23.25c-2.298 0-4.158-1.851-4.158-4.138V6.822c0-2.707 2.206-4.91 4.935-4.91h54.947c2.72 0 4.934 2.195 4.934 4.91v12.726c0 2.287-1.86 4.138-4.158 4.138h-2.767v8.565c13.312 0 24.104 10.738 24.104 23.984z"
                />
            </mask>
        </defs>

        <g clipPath="url(#clip0_2241_6488)">
            <g mask="url(#jarMask)">{children}</g>
            <path
                fill="#221F20"
                d="M89.619 167H13.38C6.003 167 0 161.027 0 153.685V56.227C0 42.6 10.645 31.387 24.096 30.408v-4.81h-.846c-3.351 0-6.08-2.715-6.08-6.05V6.822C17.17 3.059 20.246 0 24.027 0h54.948c3.781 0 6.855 3.06 6.855 6.822v12.726c0 3.335-2.728 6.05-6.08 6.05h-.845v4.81c13.459.98 24.104 12.19 24.104 25.827v97.45c0 7.342-6.003 13.315-13.382 13.315zM24.019 3.824a3.01 3.01 0 0 0-3.013 2.998v12.726a2.24 2.24 0 0 0 2.236 2.226h2.767c1.061 0 1.922.856 1.922 1.912v8.565c0 1.056-.86 1.912-1.922 1.912-12.228 0-22.174 9.897-22.174 22.065v97.457c0 5.231 4.281 9.491 9.539 9.491H89.61c5.257 0 9.538-4.26 9.538-9.491v-97.45c0-12.168-9.953-22.072-22.181-22.072a1.92 1.92 0 0 1-1.922-1.912v-8.565c0-1.056.86-1.912 1.921-1.912h2.767a2.233 2.233 0 0 0 2.237-2.226V6.822a3.01 3.01 0 0 0-3.013-2.998z"
            />
        </g>
        <defs>
            <clipPath id="clip0_2241_6488">
                <path fill="#fff" d="M0 0h103v167H0z"></path>
            </clipPath>
        </defs>
    </svg>
);
